import { FC, useEffect, useState } from "react";

import { AvailabilityItemDisplay } from "./availability-item.display";
import { AvailabilityItemEdit } from "./availability-item.edit";
import { IAvailabilityItemForm } from "./traffic-availability.models";

export const AvailabilityItem: FC<IAvailabilityItemForm> = ({
  fieldName,
  index,
  value,
  setValueOuter,
  removeHandler,
  disabledEdit,
  disabledRemove,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  return (
    <>
      {!inEdit && (
        <AvailabilityItemDisplay
          fieldName={fieldName}
          index={index}
          value={value}
          removeHandler={removeHandler}
          onEdit={() => setInEdit(true)}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
        />
      )}

      {inEdit && (
        <AvailabilityItemEdit
          fieldName={fieldName}
          setValueOuter={setValueOuter}
          index={index}
          value={value}
          onCancelOuter={() => setInEdit(false)}
        />
      )}
    </>
  );
};
